import { useState, useEffect } from "react"
import Badge from 'react-bootstrap/Badge';

import ModalAvalista from "../modals/ModalAvalista"
import moment from 'moment'

import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import LoaderIcon from 'react-loading-icons'
import api from "../components/api";

const Avalista = (props: any) => {

    const [show, setShow] = useState<boolean>(false)
    const [now, setNow] = useState<string | undefined>('')

    interface iTomadores {

        tomador_id: number,
        cpfTomador: string,
        cnpjTomador: string,
        outroDocumentoTomador: string,
        tipoJuridicoTomador: string,
        nomeTomador: string,
        nomeFantasiaTomador: string,
        razaoSocialTomador: string,

    }


    interface iDados {

        avalista_id: number,
        cliente_id: number,
        nome: string,
        cpf: string,
        nomeFantasia: string,
        tipoJuridico: string,
        cnpj: string,
        razaoSocial: string,
        bloqueado: boolean,
        outroDocumento: string,

        tomador_id: number,
        cpfTomador: string,
        cnpjTomador: string,
        outroDocumentoTomador: string,
        tipoJuridicoTomador: string,
        nomeTomador: string,
        nomeFantasiaTomador: string,
        razaoSocialTomador: string,

        tomadores: iTomadores[],

    }

    interface iClientes {

        cliente_id: number,
        nomeFantasia: string,
        cnpj: string,

    }


    const [resultado, setResultado] = useState<iDados[]>([])
    const [carregando, setCarregando] = useState<string>('none')

    const [cliente_id, setCliente_id] = useState<number | undefined>()
    const [clientes, setClientes] = useState<[]>([])
    const [avalista_id, setAvalista_id] = useState<number | undefined>()
    const [tomador_id, setTomador_id] = useState<number | undefined>()

    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')

    useEffect(() => {

        if (dadosUsuarios) {

            var dados = JSON.parse(dadosUsuarios)

            setClientes(dados.clientes)
            //setCliente_id(dados.clientes.length == 1 ? dados.clientes[0].cliente_id : undefined)
            setCliente_id(dados.clientes.length == 1 ? dados.clientes[0].cliente_id : localStorage.getItem('cliente_id') ? Number(localStorage.getItem('cliente_id')) : undefined)

        }

    }, [dadosUsuarios])



    const carregaAvalistas = () => {


        var dataPost = {

            cliente_id: cliente_id,

        }


        setCarregando('block')

        api.post('avalistaListaTodos', dataPost).then((result) => {

            setResultado(result.data.map((rs: iDados) => {

                return {

                    avalista_id: rs.avalista_id,
                    nome: rs.tipoJuridico == 'F' ? rs.nome : rs.razaoSocial,
                    cpf: rs.tipoJuridico == 'F' ? rs.cpf : rs.tipoJuridico == 'O' ? rs.outroDocumento : rs.cnpj,
                    tipoJuridico: rs.tipoJuridico,
                    bloqueado: rs.bloqueado,

                    tomador_id: rs.tomador_id,
                    cpfTomador: rs.cpfTomador,
                    cnpjTomador: rs.cnpjTomador,
                    outroDocumentoTomador: rs.outroDocumentoTomador,
                    tipoJuridicoTomador: rs.tipoJuridicoTomador,
                    nomeTomador: rs.nomeTomador,
                    nomeFantasiaTomador: rs.nomeFantasiaTomador,
                    razaoSocialTomador: rs.razaoSocialTomador,

                }

            }))
            setCarregando('none')

        }).catch((err) => {

            console.log(err.response)
            setCarregando('none')

        })

    }


    useEffect(() => {

        if (cliente_id) {

            carregaAvalistas()
            localStorage.setItem('cliente_id', String(cliente_id))

        }

    }, [cliente_id])

    const columns: MRT_ColumnDef<iDados>[] = [

        {
            accessorKey: 'tipoJuridico',
            header: 'Tipo',
            Cell: ({ renderedCellValue, row }) => (

                <Badge style={{ fontSize: '0.7rem' }} bg={renderedCellValue == 'J' ? 'info' : renderedCellValue == 'O' ? 'warning' : 'primary'}>{renderedCellValue == 'J' ? 'Pessoa Jurídica' : renderedCellValue == 'O' ? 'Outro' : 'Pessoa Física'}</Badge>

            ),

        },

        {
            accessorKey: 'nome',
            header: 'Nome/Razão Social',

        },


        {
            accessorKey: 'cpf',
            header: 'CPF/CNPJ',

        },

        {
            id: 'tomador',
            header: 'Tomador',
            accessorFn: (row) =>
            row.tipoJuridicoTomador == 'F' ? row.nomeTomador : row.tipoJuridicoTomador == 'O' ? row.nomeTomador : row.razaoSocialTomador ?? '(Vazio)',
            filterFn: 'contains',
            enableGlobalFilter: true,
            Cell: ({ renderedCellValue }) => (
                <div>
                    <li>{renderedCellValue}</li>
                </div>
            ),
        },


    ]

    return (

        <div>


            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Garantia</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">

                            <li className="breadcrumb-item active" aria-current="page">Avalista</li>
                        </ol>
                    </nav>
                </div>

            </div>

            <div className="col-md-12" style={{ marginBottom: 20 }}>
                <div className="d-md-flex d-grid align-items-center gap-2">

                    <button type="button" className="btn btn-primary" onClick={() => { setNow(moment().format('YYYY-MM-DD HH:mm:ss')); 
                                                                                        //setCliente_id(clientes.length > 1 ? undefined : cliente_id); 
                                                                                        setAvalista_id(undefined); setShow(true) }}>+ Novo</button>
                    <button type="button" className="btn btn-success" disabled>Exportar XLSX</button>

                </div>
            </div>

            <div className="row" >
                <div className="row g-3">
                    <div className="col-md-12">

                        <select className="form-control" value={cliente_id} disabled={clientes.length > 1 ? false : true} onChange={event => setCliente_id(event.target.value ? Number(event.target.value) : undefined)} >
                            {clientes.length > 1 && (<option value="">[Selecione]</option>)}

                            {

                                clientes.map((rs: iClientes) =>

                                    <option value={rs.cliente_id}>{rs.cnpj} - {rs.nomeFantasia}</option>
                                )

                            }

                        </select>
                    </div>
                    <div className="col-12 col-xl-12">


                        <center>
                            <LoaderIcon.Puff stroke="#000" style={{ display: carregando }} />
                        </center>


                        <div className="col-lg-12" style={{ display: resultado.length > 0 ? 'block' : 'none' }}>


                            <MaterialReactTable

                                columns={columns}
                                data={resultado}
                                localization={MRT_Localization_PT_BR}
                                enableGlobalFilter={true}
                                globalFilterFn="contains"
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{ density: 'compact' }}
                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                    onClick: () => {
                                        setShow(true);
                                        setAvalista_id(row.original.avalista_id)
                                        setNow(moment().format('YYYYMMDDHHmmss'))
                                    },
                                    sx: {
                                        cursor: 'pointer',
                                    },
                                })}
                            />

                        </div>



                    </div>
                </div>
            </div>

            <ModalAvalista avalista_id={avalista_id} cliente_id={cliente_id} show={show} setShow={setShow} now={now} setNow={setNow} carregaAvalistas={carregaAvalistas} />

        </div>

    )


}

export default Avalista